package com.evoapps.evoshift.domain.model

import kotlinx.serialization.Serializable

// domain/model/common/AuditMetadata.kt
@Serializable
data class AuditMetadata(
    val createdAt: String,
    val createdBy: String,
    val updatedAt: String? = null,
    val updatedBy: String? = null
)
